define('tinymce-plugins/wa5_image/image-utils',[],function() {
	return {
		initialMaxWidth: 200,
		initialMaxHeight: 200,

		/**
		 * Make sure that the image fits in the box defined by
		 *
		 * initialMaxWidth/Height
		 *
		 * @param imageDefinition, whose width and height properties are changed
		 */
		boxSize: function(imageDefinition) {
			// limit width
			var width = Math.min(this.initialMaxWidth, imageDefinition.width);
			// calculate height based on ratio
			var height = width / imageDefinition.width * imageDefinition.height;
			// limit height
			if (height > this.initialMaxHeight) {
				height = this.initialMaxHeight;
				// calculate width based on ratio
				width = height / imageDefinition.height * imageDefinition.width;
			}

			imageDefinition.width = width;
			imageDefinition.height = height;
		},

		getImageURL: function(imageDefinition) {
			if (!imageDefinition.src_x || imageDefinition.src_x == "null") {
				imageDefinition.src_x = 0;
			}
			if (!imageDefinition.src_y || imageDefinition.src_y == "null") {
				imageDefinition.src_y = 0;
			}
			if (!imageDefinition.src_h || imageDefinition.src_h == "null") {
				imageDefinition.src_h = -1;
			}
			if (!imageDefinition.src_w || imageDefinition.src_w == "null") {
				imageDefinition.src_w = -1;
			}

			return '/images/' + imageDefinition.id + '?x=' + imageDefinition.src_x +
						'&y=' + imageDefinition.src_y +
						'&h=' + imageDefinition.src_h +
						'&w=' + imageDefinition.src_w;
		}
	};
});

